(function () {
  var WA_BASE = 'https://wa.me/';
  var STORAGE_KEY = 'onceIdealInterestList';
  var DEFAULT_NUMBER = '527295500153';

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage no disponible; la sesión sigue funcionando sin lista persistente */
    }
    document.dispatchEvent(new CustomEvent('once-ideal:list-updated', { detail: { list: list } }));
  }

  function addToList(item) {
    var list = getList();
    list.push(item);
    saveList(list);
  }

  function removeIndex(index) {
    var list = getList();
    list.splice(index, 1);
    saveList(list);
  }

  function clearList() {
    saveList([]);
  }

  function countInList(variantId) {
    var list = getList();
    var count = 0;
    list.forEach(function (item) {
      if (String(item.variantId) === String(variantId)) count++;
    });
    return count;
  }

  // Groups raw list entries (one per unit) into { productTitle, talla, available, waNumber, qty, rawIndexes }
  function groupList(list) {
    var groups = [];
    var indexByKey = {};
    list.forEach(function (item, i) {
      var key = (item.variantId != null ? item.variantId : item.talla) + '|' + item.productTitle;
      if (!(key in indexByKey)) {
        indexByKey[key] = groups.length;
        groups.push({
          productTitle: item.productTitle,
          talla: item.talla,
          available: item.available,
          waNumber: item.waNumber,
          qty: 0,
          rawIndexes: []
        });
      }
      var g = groups[indexByKey[key]];
      g.qty += 1;
      g.rawIndexes.push(i);
    });
    return groups;
  }

  function buildSingleGroupMessage(g) {
    var count = g.qty || 1;
    var jerseyWord = count > 1 ? 'jerseys' : 'jersey';
    var base = 'Hola, me interesa' + (count > 1 ? 'n ' + count + ' ' : ' la ') + jerseyWord + ' ' + g.productTitle;
    if (g.talla) base += ', ' + g.talla;
    base += '. ' + (count > 1 ? 'Las vi' : 'La vi') + ' en el catálogo de Once Ideal';
    if (g.available) {
      base += ' y quisiera consultar disponibilidad.';
    } else {
      base += ' (Por encargo, ~20 días hábiles) y quisiera consultar tiempos y precio.';
    }
    return base;
  }

  function buildMultiGroupMessage(groups) {
    var lines = ['Hola, me interesan estas jerseys del catálogo de Once Ideal:'];
    groups.forEach(function (g, i) {
      var estado = g.available ? 'Disponible' : 'Por encargo, ~20 días hábiles';
      var qtyPrefix = g.qty > 1 ? g.qty + 'x ' : '';
      var line = (i + 1) + '. ' + qtyPrefix + g.productTitle;
      if (g.talla) line += ', ' + g.talla;
      line += ' (' + estado + ')';
      lines.push(line);
    });
    lines.push('¿Me pueden confirmar disponibilidad, tiempos y precio?');
    return lines.join('\n');
  }

  function buildMessageFromGroups(groups) {
    if (groups.length === 1) return buildSingleGroupMessage(groups[0]);
    return buildMultiGroupMessage(groups);
  }

  function waLink(number, message) {
    return WA_BASE + (number || DEFAULT_NUMBER) + '?text=' + encodeURIComponent(message);
  }

  function initCtaBlocks() {
    var blocks = document.querySelectorAll('[data-once-ideal-wa-cta]');
    blocks.forEach(function (block) {
      if (block.dataset.onceIdealWired) return;
      block.dataset.onceIdealWired = 'true';

      var waNumber = block.getAttribute('data-wa-number') || DEFAULT_NUMBER;
      var productTitle = block.getAttribute('data-product-title') || '';
      var variantsScript = block.querySelector('[data-once-ideal-variants]');
      var variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }

      var optionGroups = Array.prototype.slice.call(block.querySelectorAll('[data-once-ideal-option]'));
      var confirmEl = block.querySelector('[data-once-ideal-confirm]');
      var addBtn = block.querySelector('[data-once-ideal-add-to-list]');
      var optionCount = optionGroups.length;
      var selections = new Array(optionCount).fill(null);

      // Paint availability dots per pill (independent of current selection: does any
      // variant carrying this value, at this option position, have real deny+stock?)
      optionGroups.forEach(function (group, idx) {
        var pills = group.querySelectorAll('[data-once-ideal-pill]');
        pills.forEach(function (pill) {
          var val = pill.getAttribute('data-value');
          var optKey = 'option' + (idx + 1);
          var hasStock = variants.some(function (v) {
            return v[optKey] === val && v.inventory_policy === 'deny' && (v.inventory_quantity || 0) > 0;
          });
          var dot = pill.querySelector('[data-once-ideal-dot]');
          if (dot) dot.setAttribute('data-state', hasStock ? 'stock' : 'encargo');

          pill.addEventListener('click', function () {
            pills.forEach(function (p) {
              p.classList.remove('is-selected');
            });
            pill.classList.add('is-selected');
            selections[idx] = val;
            refreshConfirm();
          });
        });
      });

      function findVariant() {
        if (optionCount === 0) return variants[0] || null;
        if (selections.indexOf(null) !== -1) return null;
        return (
          variants.filter(function (v) {
            for (var i = 0; i < optionCount; i++) {
              if (v['option' + (i + 1)] !== selections[i]) return false;
            }
            return true;
          })[0] || null
        );
      }

      function computeState(variant) {
        var trackable = variant.inventory_management != null;
        if (!trackable) return { state: 'disponible', remaining: null };
        if (variant.inventory_policy === 'continue') return { state: 'encargo' };

        var originalQty = Math.max(0, variant.inventory_quantity || 0);
        if (originalQty === 0) return { state: 'encargo' };

        var remaining = originalQty - countInList(variant.id);
        if (remaining > 0) return { state: 'disponible', remaining: remaining };
        return { state: 'agotado' };
      }

      function refreshConfirm() {
        var variant = findVariant();
        if (!variant) {
          confirmEl.hidden = true;
          addBtn.disabled = true;
          return;
        }

        var result = computeState(variant);
        var label = variant.title.split(' / ').join(', ');
        var badgeHtml;

        if (result.state === 'disponible') {
          var unidad = result.remaining == null ? '' : ' — ' + result.remaining + (result.remaining === 1 ? ' unidad' : ' unidades');
          badgeHtml = '🟢 Disponible' + unidad;
        } else if (result.state === 'encargo') {
          badgeHtml = '🟡 Disponible por encargo — ~20 días hábiles';
        } else {
          badgeHtml = '🔴 Esta combinación ya no está disponible en stock. Disponible por encargo.';
        }

        confirmEl.innerHTML = optionCount > 0 ? '<strong>' + label + '</strong><br>' + badgeHtml : badgeHtml;
        confirmEl.hidden = false;
        addBtn.disabled = false;
        addBtn.dataset.variantId = variant.id;
        addBtn.dataset.talla = variant.title;
        addBtn.dataset.available = result.state === 'disponible' ? 'true' : 'false';
      }

      addBtn.addEventListener('click', function () {
        var variant = findVariant();
        if (!variant) return;
        var result = computeState(variant);

        addToList({
          productTitle: productTitle,
          variantId: variant.id,
          talla: variant.title,
          available: result.state === 'disponible',
          waNumber: waNumber
        });

        var originalText = addBtn.textContent;
        addBtn.textContent = 'Agregada ✓';
        setTimeout(function () {
          addBtn.textContent = originalText;
        }, 1200);

        selections = new Array(optionCount).fill(null);
        optionGroups.forEach(function (group) {
          group.querySelectorAll('[data-once-ideal-pill]').forEach(function (p) {
            p.classList.remove('is-selected');
          });
        });

        if (optionCount === 0) {
          refreshConfirm();
        } else {
          confirmEl.hidden = true;
          addBtn.disabled = true;
        }
      });

      // Keep the "remaining" count correct if items are removed from the list elsewhere
      document.addEventListener('once-ideal:list-updated', function () {
        if (optionCount === 0 || selections.indexOf(null) === -1) {
          refreshConfirm();
        }
      });

      if (optionCount === 0) refreshConfirm();
    });
  }

  function initWidget() {
    var widget = document.querySelector('[data-once-ideal-widget]');
    if (!widget || widget.dataset.onceIdealWired) return;
    widget.dataset.onceIdealWired = 'true';

    var countEl = widget.querySelector('[data-once-ideal-widget-count]');
    var panel = widget.querySelector('[data-once-ideal-widget-panel]');
    var itemsEl = widget.querySelector('[data-once-ideal-widget-items]');
    var sendBtn = widget.querySelector('[data-once-ideal-widget-send]');
    var clearBtn = widget.querySelector('[data-once-ideal-widget-clear]');
    var toggleBtn = widget.querySelector('[data-once-ideal-widget-toggle]');

    function render() {
      var list = getList();
      var groups = groupList(list);

      if (countEl) countEl.textContent = list.length;
      widget.style.display = list.length > 0 ? 'block' : 'none';

      if (itemsEl) {
        itemsEl.innerHTML = '';
        groups.forEach(function (g) {
          var row = document.createElement('div');
          row.className = 'once-ideal-widget__item';

          var label = document.createElement('span');
          var estado = g.available ? 'Disponible' : 'Por encargo';
          var qtyPrefix = g.qty > 1 ? g.qty + 'x ' : '';
          label.textContent = qtyPrefix + g.productTitle + (g.talla ? ' — ' + g.talla : '') + ' (' + estado + ')';

          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'once-ideal-widget__remove';
          removeBtn.setAttribute('aria-label', 'Quitar una unidad');
          removeBtn.textContent = '✕';
          removeBtn.addEventListener('click', function () {
            removeIndex(g.rawIndexes[g.rawIndexes.length - 1]);
          });

          row.appendChild(label);
          row.appendChild(removeBtn);
          itemsEl.appendChild(row);
        });
      }

      if (sendBtn) {
        sendBtn.onclick = function () {
          var currentGroups = groupList(getList());
          if (currentGroups.length === 0) return;
          var number = currentGroups[0].waNumber || DEFAULT_NUMBER;
          window.open(waLink(number, buildMessageFromGroups(currentGroups)), '_blank', 'noopener');
        };
      }
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearList();
      });
    }

    if (toggleBtn && panel) {
      toggleBtn.addEventListener('click', function () {
        panel.classList.toggle('once-ideal-widget__panel--open');
      });
    }

    document.addEventListener('once-ideal:list-updated', render);
    render();
  }

  function init() {
    initCtaBlocks();
    initWidget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
